var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckBullet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.637,
    height: 27.637,
    viewBox: "0 0 27.637 27.637",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38267",
    "data-name": "Group 38267",
    transform: "translate(-1273.893 -4983.893)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_530",
    "data-name": "Ellipse 530",
    cx: 13.819,
    cy: 13.819,
    r: 13.819,
    transform: "translate(1273.893 4983.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15296",
    "data-name": "Path 15296",
    d: "M24.372,6l-8.363,8.372L13.5,11.863",
    transform: "translate(1268.771 4987.526)",
    fill: "none",
    stroke: "#2ecf96",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBullet);
export default __webpack_public_path__ + "static/media/check-bullet.ad8f57095b2871381f8097f65887a829.svg";
export { ForwardRef as ReactComponent };